import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../common/Auth";
import SectionTitle from "../../components/section-title/SectionTitle";
import EditFeaturedProductIcon from "./editfeaturedProduct/EditFeaturedProductIcon";
import FeaturedProductGrid from "./FeaturedProductGrid";

const FeaturedProducts = ({
  spaceTopClass,
  spaceBottomClass,
  bgColorClass,
  category
}) => {
  const [featuredproductSettings, setFeaturedproductSettings] = useState(null)
  const [productSettings, setProductSettings] = useState(null);
  const { themeSettingsData, userType } = useContext(AuthContext)
  useEffect(() => {
    if (themeSettingsData && themeSettingsData.length > 0) {
      let flag = true
      themeSettingsData.map((i) => {
        if (i.settingsName === "featuredProducts") {
          flag = false
          setFeaturedproductSettings(i.values[0]);
        }
      })
      if (flag) {
        setFeaturedproductSettings({});
      }
      let componentMounted = true;
      return () => {
        componentMounted = false;
      }
    }
  }, [themeSettingsData])
  if (!featuredproductSettings) {
    return ""
  }
  let titleStyle = {};
  let subTitleStyle = {};

  if (featuredproductSettings) {
    titleStyle = {
      fontSize: featuredproductSettings.sectionTitleFontSize > 0 ? featuredproductSettings.sectionTitleFontSize + "px" : "",
      fontFamily: featuredproductSettings.sectionTitleFont,
      color: featuredproductSettings.sectionTitleColor ? featuredproductSettings.sectionTitleColor : ""
    }
    subTitleStyle = {
      fontSize: featuredproductSettings.sectionSubTitleFontSize > 0 ? featuredproductSettings.sectionSubTitleFontSize + "px" : "",
      fontFamily: featuredproductSettings.sectionSubTitleFont,
      color: featuredproductSettings.sectionSubTitleColor ? featuredproductSettings.sectionSubTitleColor : ""
    }
  }


  let pt = featuredproductSettings.paddingTop ? featuredproductSettings.paddingTop : "pt-50";
  let pb = featuredproductSettings.paddingBottom ? featuredproductSettings.paddingBottom : "pb-50";
  let mb = featuredproductSettings.marginBottom ? featuredproductSettings.marginBottom : "mt-50";
  let mt = featuredproductSettings.marginTop ? featuredproductSettings.marginTop : "mb-50";
  let mr = featuredproductSettings.marginRight ? featuredproductSettings.marginRight : "mr-0";
  let ml = featuredproductSettings.marginLeft ? featuredproductSettings.marginLeft : "ml-0";
  let pl = featuredproductSettings.paddingLeft ? featuredproductSettings.paddingLeft : "pl-0";
  let pr = featuredproductSettings.paddingRight ? featuredproductSettings.paddingRight : "pr-0";
  let fullSection = featuredproductSettings.fullSection ? "container-fluid" : "container";
  let bgImage = featuredproductSettings?.bgImage ? featuredproductSettings?.bgImage : "";
  let bgColor = featuredproductSettings?.bgColor ? featuredproductSettings?.bgColor : "";
  let tagsData = []
  return (
    <div
      className={`antera-featured-products-section-container product-area section-bgImage ${pt} ${pb} ${pl} ${pr} ${mb} ${mt} ${mr} ${ml} ${bgColorClass ? bgColorClass : ""}`}
      style={(bgImage.length > 0 ) ? {backgroundImage:`url(${bgImage})`} : {background:bgColor}}
    >
      <div className={`antera-featured-products-content-container ${fullSection}`}>
        <div className="edit-img">
          <EditFeaturedProductIcon />
        </div>
        {(featuredproductSettings && (featuredproductSettings.sectionTitleEnabled || featuredproductSettings.sectionSubTitleEnabled)) &&
          <SectionTitle
            titleStyle={titleStyle}
            subTitleStyle={subTitleStyle}
            titleText={featuredproductSettings.sectionTitleEnabled ? (featuredproductSettings && featuredproductSettings.sectionTitle != "") ? featuredproductSettings.sectionTitle : "DAILY DEALS!" : null}
            subTitleText={featuredproductSettings.sectionSubTitleEnabled ? (featuredproductSettings && featuredproductSettings.sectionSubTitle != "") ? featuredproductSettings.sectionSubTitle : "" : null}
            titlepositionClass={featuredproductSettings.sectionTitleAlign}
            subtitlepositionClass={featuredproductSettings.sectionSubTitleAlign}
            borderClass={featuredproductSettings.sectionTitleBorder} />}
        <div className="row">
          <FeaturedProductGrid
            category={category}
            type="new"
            limit={(featuredproductSettings && featuredproductSettings.numberoffeaturedProducts) ? featuredproductSettings.numberoffeaturedProducts : "8"}
            spaceBottomClass="mb-25"
          />
        </div>
        {featuredproductSettings.showViewAllProducts && (
          <div className="view-more text-center mt-20 toggle-btn6 col-12">
            <Link
              className="loadMore6"
              to={process.env.PUBLIC_URL + "/products"}
            >
              VIEW ALL PRODUCTS
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

FeaturedProducts.propTypes = {
  bgColorClass: PropTypes.string,
  category: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};

export default FeaturedProducts;
